/* eslint-disable no-redeclare */
import * as t from "io-ts"
import { cast, maybe, Maybe } from "@flockcover/flock-svc-core-types"

export interface AuthService {
  resetPassword: (email: string) => Promise<void>
  login: (credentials: AuthCredentials) => Promise<boolean>
  logout: () => Promise<void>
  isAuthenticated: () => boolean
  getAuthId: () => Maybe<string>
  getAuthType: () => Maybe<AuthUserType>
  getAuthUser: () => Maybe<AuthUser>
}

const AuthUserUnionType = t.union([
  t.literal(`customer`),
  t.literal(`admin`),
  t.literal(`distributor`),
  t.literal(`claims_admin`),
  t.literal(`carrier`),
])

const AuthUserType = t.type({
  id: t.string,
  type: AuthUserUnionType,
  ownerId: maybe(t.string),
})

const AuthCredentialsType = t.type({
  email: t.string,
  password: t.string,
})

const JWTAuthDataType = t.type({
  id: t.string,
  expiresAt: t.number,
  type: AuthUserUnionType,
  ownerId: maybe(t.string),
})

export const makeAuthUser = cast(AuthUserType)
export const makeJWTAuthData = cast(JWTAuthDataType)
export const makeAuthCredentials = cast(AuthCredentialsType)

export type AuthUserType = t.TypeOf<typeof AuthUserUnionType>
export type AuthUser = t.TypeOf<typeof AuthUserType>
export type JWTAuthData = t.TypeOf<typeof JWTAuthDataType>
export type AuthCredentials = t.TypeOf<typeof AuthCredentialsType>
